import { call, put, takeLatest } from 'redux-saga/effects';
import { message } from 'antd';
import * as types from '../constants/actionTypes';
import * as actions from '../actions/paymentActions';
import { paymentsAPI } from '../../api/config';

function* createPaymentSaga(action) {
  try {
    const response = yield call(paymentsAPI.createPayment, action.payload);
    yield put(actions.createPaymentSuccess(response.data));
    message.success('Payment recorded successfully');
    // Refresh the bill payments section
    const billId = action.payload.bill_receipt_id;
    if (billId) {
      yield put(actions.fetchBillPaymentsRequest(billId));
    }
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to record payment';
    yield put(actions.createPaymentFailure(msg));
    message.error(msg);
  }
}

function* fetchBillPaymentsSaga(action) {
  try {
    const response = yield call(paymentsAPI.getBillPayments, action.payload);
    yield put(actions.fetchBillPaymentsSuccess(action.payload, response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch payments';
    yield put(actions.fetchBillPaymentsFailure(msg));
  }
}

function* fetchBillPaymentSummarySaga(action) {
  try {
    const response = yield call(paymentsAPI.getBillPaymentSummary, action.payload);
    yield put(actions.fetchBillPaymentSummarySuccess(action.payload, response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch payment summary';
    yield put(actions.fetchBillPaymentSummaryFailure(msg));
  }
}

function* fetchAllPaymentsSaga(action) {
  try {
    const response = yield call(paymentsAPI.listPayments, action.payload);
    yield put(actions.fetchAllPaymentsSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch payments';
    yield put(actions.fetchAllPaymentsFailure(msg));
    message.error(msg);
  }
}

function* fetchPaymentStatisticsSaga(action) {
  try {
    const response = yield call(paymentsAPI.getStatistics, action.payload);
    yield put(actions.fetchPaymentStatisticsSuccess(response.data));
  } catch (error) {
    const msg = error.response?.data?.error || 'Failed to fetch payment statistics';
    yield put(actions.fetchPaymentStatisticsFailure(msg));
    message.error(msg);
  }
}

export default function* paymentSaga() {
  yield takeLatest(types.CREATE_PAYMENT_REQUEST, createPaymentSaga);
  yield takeLatest(types.FETCH_BILL_PAYMENTS_REQUEST, fetchBillPaymentsSaga);
  yield takeLatest(types.FETCH_BILL_PAYMENT_SUMMARY_REQUEST, fetchBillPaymentSummarySaga);
  yield takeLatest(types.FETCH_ALL_PAYMENTS_REQUEST, fetchAllPaymentsSaga);
  yield takeLatest(types.FETCH_PAYMENT_STATISTICS_REQUEST, fetchPaymentStatisticsSaga);
}
